const Services = () => {
    return (
      <>
        <p>This is a new Services page</p>
      </>
    );
  };
  
  export default Services;